import { Layout, Card, Loading } from 'element-react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';

import ProductSwiperItem from './ProductSwiperItem';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default function ProductsSwiper({ slidesPerView, spaceBetween, products, loading }) {
    const { t } = useTranslation();

    function renderProducts() {
        return products && products.map(product => {
            return(
                <SwiperSlide className="swiper-item" key={product.id}>
                    <ProductSwiperItem product={product} />
                </SwiperSlide>
            )
        })
    }

    console.log("products swiper:")
    console.log(products)

    return (
        <Layout.Row  className="featured-products-carousel">
            <Layout.Col span="24" style={{paddingRight: '0px', paddingLeft: '0px'}}>
                <Card className="box-card">
                    <Layout.Row>
                        <Layout.Col span="24" style={{paddingRight: '0px', paddingLeft: '0px'}}>
                            { loading ? 
                                <Loading className="p-t-md p-b-xl" text={t('general.loading')} loading={true} fullscreen={false}/>
                                :
                                
                                <Swiper 
                                    slidesPerView={4} 
                                    spaceBetween={spaceBetween}                     
                                    navigation={true}
                                    loop={true}
                                    breakpoints={{
                                        344: {
                                          slidesPerView: 2,
                                          spaceBeetween: 10,
                                        },
                                        640: {
                                          slidesPerView: 2,
                                          spaceBetween: 10,
                                        },
                                        1024: {
                                            slidesPerView: 4,
                                            spaceBetween: 10
                                        },
                                        1200: {
                                            slidesPerView: 4, 
                                            spaceBetween: 20,
                                            
                                        }
                                      }}  
                                >
                                    { renderProducts() }
                                </Swiper>
                            }
                        </Layout.Col>
                    </Layout.Row>
                </Card>
            </Layout.Col>
        </Layout.Row>
    )
}
